import React from 'react';
import PropTypes from 'prop-types';
import PowerBiReport, {
  POWER_BI_DISPLAY_OPTIONS,
} from 'components/PowerBiReport';

const PowerBiReportFullPage = props => (
  <PowerBiReport
    {...props}
    isFullPage
    displayOption={POWER_BI_DISPLAY_OPTIONS.actualSize}
  />
);

PowerBiReportFullPage.propTypes = {
  tokenUrl: PropTypes.string,
  accessibleTitle: PropTypes.string,
  lang: PowerBiReport.propTypes.lang,
};

export default PowerBiReportFullPage;
